document.addEventListener("DOMContentLoaded", function () {
    const mDigiCounterSections = document.querySelectorAll('.m_digi_banner');
    
    mDigiCounterSections.forEach(section => {
        const sectionId = section.dataset.id;
        const countdownElement = section.querySelector(".m_digi_banner__countdown");

        if ( countdownElement ) {
            const year = countdownElement.dataset.startYear;
            const month = countdownElement.dataset.startMonth;
            const day = countdownElement.dataset.startDay;
            const time = countdownElement.dataset.startTime;
            const endDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${time}`;
    
            function updateCountdown() {
                const now = new Date().getTime();
                const distance = new Date(endDate).getTime() - now; // Correction pour la comparaison avec le bon format
    
                if (!countdownElement) {
                    console.warn(`Element .m_digi_banner__${sectionId} not found`);
                    return;
                }
    
                if (distance < 0) {
                    clearInterval(intervalId); // Arrêter l'intervalle
                    section.style.display = "none"; // Cacher la section
                    return;
                }
    
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
                section.querySelector(`#days_${sectionId}`).textContent = days;
                section.querySelector(`#hours_${sectionId}`).textContent = hours;
                section.querySelector(`#minutes_${sectionId}`).textContent = minutes;
                section.querySelector(`#seconds_${sectionId}`).textContent = seconds;
            }
    
            const intervalId = setInterval(updateCountdown, 1000);
            updateCountdown();
        }
    });
});
